<template>
  <div class="dist18-container" v-show="districts.length > 0">
    <div class="atomic-district-container">
      <atomic-district
        v-for="district in districts"
        :key="district.dist_code"
        class="atomic-district"
        :region="region"
        :district18="district18"
        :district="district"
        @changeDistrict="$emit('changeDistrict', $event)"
      />
    </div>
  </div>
</template>

<script>
import MdCheckbox from '@/components/MaterialCheckbox';
import AtomicDistrict from '@/components/Stock/Filters/AtomicDistrict';

export default {
  props: ['region', 'district18', 'selectedIcs'],
  components: {
    AtomicDistrict,
    MdCheckbox,
  },
  computed: {
    districts() {
      if (this.selectedIcs) {
        return this.district18.district.filter(d => d.ics_type.some(it => it === this.selectedIcs));
      }
      return this.district18.district;
    },
    isChecked() {
      if (this.districts.length > 0) {
        return this.districts.every(d => d.isChecked);
      }
      return false;
    },
  },
  watch: {
    selectedIcs(value, oldValue) {
      const districtActions = {};

      // Is district 18 checked before the ICS change?
      let preChecked = false;
      if (oldValue) {
        const preDistricts = this.district18.district
          .filter(d => d.ics_type.some(it => it === oldValue));
        preChecked = preDistricts.length > 0 ?
          preDistricts.every(d => d.isChecked) :
          false;
      }

      if (value) {
        this.district18.district.forEach((d) => {
          if (!d.ics_type.some(it => it === value)) {
            if (d.isChecked) {
              districtActions[d.dist_code] = false;
            }
          } else if (preChecked) {
            districtActions[d.dist_code] = true;
          }
        });
      } else {
        this.district18.district.forEach((d) => {
          if (preChecked) {
            districtActions[d.dist_code] = true;
          }
        });
      }

      if (Object.keys(districtActions).length > 0) {
        this.$emit('changeDistrict', districtActions);
      }
    },
  },
  methods: {
    change() {
      const checked = !this.isChecked;
      const districtActions = {};
      this.districts.forEach((d) => {
        districtActions[d.dist_code] = checked;
      });
      this.$emit('changeDistrict', districtActions);
    },
  },
};
</script>

<style scoped>
.dist18-container {
  margin-bottom: 5px;
  white-space: normal;
}

.dist18-checkbox {
  margin-bottom: 0;
}

.dist18-label {
  font-size: 16px;
}

.atomic-district-container {
  margin-left: 29px;
}

.atomic-district-container .atomic-district {
  margin-right: 15px;
}
</style>
